import { useEffect } from 'react'
import { Capacitor, SystemBars, SystemBarType, SystemBarsStyle } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'
import { useColorScheme } from '@mui/material/styles'
import { system_bar_colors, type SystemBarColorScheme } from '../theme'

const is_native = Capacitor.isNativePlatform()

export const colorSchemeToStatusBarStyle = (color_scheme: string | null | undefined): Style =>
  color_scheme === 'dark' ? Style.Dark : Style.Light

export const colorSchemeToSystemBarsStyle = (color_scheme: string | null | undefined): SystemBarsStyle =>
  color_scheme === 'dark' ? SystemBarsStyle.Dark : SystemBarsStyle.Light

export const resolveSystemBarColorScheme = (color_scheme: string | null | undefined): SystemBarColorScheme =>
  color_scheme === 'dark' ? 'dark' : 'light'

// index.html には prefers-color-scheme 別の theme-color が2枚ある（JS読み込み前の初期値）。
// どのmediaが一致するかはOS設定次第なので、アプリ内で選択中のモードを優先させるため全部を同じ色にする。
export const applyThemeColorMeta = (color: string) => {
  document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')
    .forEach((meta) => { meta.content = color })
}

export const applySystemBarColors = (color_scheme: string | null | undefined) => {
  const scheme = resolveSystemBarColorScheme(color_scheme)

  StatusBar.setStyle({ style: colorSchemeToStatusBarStyle(color_scheme) })
  // Android 16+ は強制edge-to-edgeのため no-op になる（その場合はヘッダーの背景が枠に透ける）。
  // Android 15以下と iOS では実際に塗られる。
  StatusBar.setBackgroundColor({ color: system_bar_colors[scheme].status })
  // ナビゲーションバーのアイコン色。@capacitor/core 同梱の SystemBars を使うので追加依存は不要。
  // 背景色は edge-to-edge でボトムナビゲーションが透けるため設定しない。
  SystemBars.setStyle({
    bar: SystemBarType.NavigationBar,
    style: colorSchemeToSystemBarsStyle(color_scheme),
  })
}

export default function useSyncSystemBars () {
  const { colorScheme } = useColorScheme()

  useEffect(() => {
    applyThemeColorMeta(system_bar_colors[resolveSystemBarColorScheme(colorScheme)].status)

    if (!is_native || !FEATURE_DARK_MODE) return
    applySystemBarColors(colorScheme)
  }, [colorScheme])
}
